
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { MyaccountComponent } from '../collabo/myaccount.component';
import { CostComponent } from './cost.component';
import { InitiatorChangePwdComponent } from './initiatorchangepwd.component';
import { InitiatorCollaboComponent } from './initiatorcollabo.component';
import { InitiatorDashboardComponent } from './initiatordashboard.component';

import { InitiatorHeadComponent } from './initiatorhead.component';
import { InitiatorMessageComponent } from './initiatormessage.component';
import { InitiatorMyaccountComponent } from './initiatormyaccount.component';
import { InitiatorPostcollaboComponent } from './initiatorpostcollabo.component';
import { PayComponent } from './pay.component';

import {MessagesComponent} from './messages/messages.component';

const routes: Routes = [
    // {
    //   path: 'initatorhead',
    //   component: InitiatorHeadComponent, // this is the component with the <router-outlet> in the template
    //   data: {
    //     title: 'Initiatorhead'
    //   },
    //   children: [
        
        {
          path: 'initatorcollabo/:collaboID/:screen', // child route path
          component: InitiatorCollaboComponent, // child route component that the router renders
          data: {
            title: 'InitiatorCollabo'
          },
        },
        
        {
          path: 'initatorpostcollabo/:collaboID/:type',
          component: InitiatorPostcollaboComponent, // another child route component that the router renders
          data: {
            title: 'InitiatorPostCollabo'
          },
        },
        {
            path: 'cost',
            component: CostComponent, // another child route component that the router renders
            data: {
              title: 'InitiatorCost'
            },
          },
          {
              path:'initatormessage',
              component:InitiatorMessageComponent,
              data: {
                title: 'InitiatorMessage'
              },
          },
          {path:'initatordashboard', component: InitiatorDashboardComponent,
          data: {
            title: 'InitiatorDashboard'
          },},
          {path:'pay', component: PayComponent,
          data: {
            title: 'InitiatorPay'
          },},
          // {path:'initatormyaccount', component: MyaccountComponent},
          {path:'initatorcpwd', component: InitiatorChangePwdComponent,
          data: {
            title: 'InitiatorChangepassword'
          },},
          {path:'messages/:userID/:chatid/:collaboid',component:MessagesComponent,
          data: {
            title: 'InitiatorMessages'
          },},
    //   ],
    // },
  ];




// const routes: Routes = [
//     { path: 'initatorhead', component: InitiatorHeadComponent },
//     { path: 'initatorcollabo', component: InitiatorCollaboComponent },
//     { path: 'initatorpostcollabo', component: InitiatorPostcollaboComponent },
//     { path: 'cost', component: CostComponent },
//     { path: 'initatormessage', component: InitiatorMessageComponent },
//     { path: 'initatordashboard', component: InitiatorDashboardComponent },
//     { path: 'pay', component: PayComponent },
//     { path: 'initatormyaccount', component: InitiatorMyaccountComponent },
//     { path: 'initatorcpwd', component: InitiatorChangePwdComponent }
    
// ];

@NgModule({
    imports: [ CommonModule,RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InitiatorRoutingModule {}
